import { useCallback, useState } from 'react';
import CheckoutModal from '../components/payment/CheckoutModal';
import { createPortal } from 'react-dom';
import { trackEvent } from '../utils/analytics';

export default function usePayment() {
  const [modalState, setModalState] = useState(null);

  const openPayment = useCallback((opts) => {
    const { targetTier, currentTier = 'free', userId = 'anonymous', sourceContext = 'unknown', onSuccess = null } = opts || {};
    setModalState({ targetTier, currentTier, userId, sourceContext, onSuccess });
    trackEvent('payment_opened', { targetTier, currentTier, sourceContext });
  }, []);

  const closePayment = useCallback(() => setModalState(null), []);

  const modal = modalState
    ? createPortal(
        <CheckoutModal
          isOpen
          onClose={closePayment}
          targetTier={modalState.targetTier}
          currentTier={modalState.currentTier}
          userId={modalState.userId}
          sourceContext={modalState.sourceContext}
          onSuccess={modalState.onSuccess}
        />, document.body)
    : null;

  return { openPayment, closePayment, modal };
}


